import React from 'react';

export const LazyBlueprintWelcome = React.lazy(() =>
  import('./BlueprintWelcome').then((module) => ({
    default: module.BlueprintWelcome,
  }))
);
